/**
 * Starts fetching an image at high priority before the element that shows it exists, so the
 * download overlaps the render work instead of following it. No-op for an empty URL or one
 * already preloaded.
 */
export const preloadImageWithHighPriority = (url) => {
  if (!url || typeof document === 'undefined') return
  const alreadyPreloaded = [...document.head.querySelectorAll('link[rel="preload"][as="image"]')]
    .some((link) => link.getAttribute('href') === url)
  if (alreadyPreloaded) return
  const link = document.createElement('link')
  link.setAttribute('rel', 'preload')
  link.setAttribute('as', 'image')
  link.setAttribute('href', url)
  link.setAttribute('fetchpriority', 'high')
  document.head.appendChild(link)
}
